import cn from "@/util/cn";
import { ComponentPropsWithoutRef, PropsWithChildren } from "react";

type IconButtonVariant = "neutral" | "danger";

type IconButtonProps = { variant: IconButtonVariant } & ComponentPropsWithoutRef<"button">;

const styleForVariant = (variant: IconButtonVariant) => {
  switch (variant) {
    case "neutral":
      return "text-primary/90 focus-visible:outline-gray-100 hover:bg-primary/10 hover:disabled:bg-transparent";
    case "danger":
      return "text-red-600 focus-visible:outline-red-600 hover:bg-red-200 disabled:text-primary/90 hover:disabled:bg-transparent";
  }
};

const IconButton = ({
  variant,
  className,
  children,
  ...otherProps
}: PropsWithChildren<IconButtonProps>) => {
  const style = styleForVariant(variant);
  return (
    <button
      className={cn(
        `whitespace-nowrap flex cursor-pointer select-none items-center justify-center overflow-hidden rounded-md px-1 py-1 focus-visible:outline-solid focus-visible:outline-2 focus-visible:outline-offset-2 disabled:cursor-not-allowed disabled:opacity-50`,
        style,
        className
      )}
      {...otherProps}
    >
      {children}
    </button>
  );
};

export default IconButton;
